export default {
  sKey: {
    Khonglamtrontien: "Khonglamtrontien",
    sanphamtheochinhanh: "sanphamtheochinhanh",
    duocthemdaura: "duocthemdaura",
    SuaDonHangCoLsx: "SuaDonHangCoLsx",
    IsConfigQuanLyKhoiLuong: "IsConfigQuanLyKhoiLuong",
    TonKhoShowMaCuon: "TonKhoShowMaCuon",
    giaBanTheoSoLuong: "giaBanTheoSoLuong",
    IsChanSoLuongKhiTaoDonBaoGia: "IsChanSoLuongKhiTaoDonBaoGia",
    SUDUNGMACTHEP: "SUDUNGMACTHEP",
    AutoNhapKho: "AutoNhapKho",
    AutoTruKho: "AutoTruKho",
    AUTO_EDIT_DATETIME_TRANSACTION: "AUTO_EDIT_DATETIME_TRANSACTION",
    THONGTIN_FORM_IN: "THONGTIN_FORM_IN",
    IsChietKhauSP: "IsChietKhauSP",
    IsChonTTK: "IsChonTTK",
    KeyPhienBan: "KeyPhienBan",
    DoanhNghiepFull: "DoanhNghiepFull",
    IsModulNhomKinh: "IsModulNhomKinh",
    IsModulGiaCong: "IsModulGiaCong",
    IsLblQLThuMua: "IsLblQLThuMua",
    DefaultGhiChuBaoGia: "DefaultGhiChuBaoGia",
    ConfigMaPO: "ConfigMaPO",
    ConfigThongTinLSX: "ConfigThongTinLSX",
    ConfigBaoGiaChot: "ConfigBaoGiaChot",
    IsDieuChinhLuongXuatLSX: "IsDieuChinhLuongXuatLSX",
    ConfigChiPhiGiaThanh: "ConfigChiPhiGiaThanh",
    ConfigDonVi: "ConfigDonVi",
    chiphisanxuat: "chiphisanxuat",
    ConfigVAT: "ConfigVAT",
    isShowDHQuaHan: "isShowDHQuaHan",
    MauHoaDonPrint: "MauHoaDonPrint",
    isShowHoaDonGTGT: "isShowHoaDonGTGT",
    ConfigTienLai: "ConfigTienLai",
    shownhanvienkinhdoanh: "shownhanvienkinhdoanh",
    chonmaysx: "chonmaysx",
    showphepham: "showphepham",
    truTienTraHangDonHangConNo: "truTienTraHangDonHangConNo",
    IsHDDTToken: "IsHDDTToken",
    Account: "HDDTVNPT_UserName",
    ACpass: "HDDTVNPT_Password",
    username: "HDDTVNPT_UserNameService",
    password: "HDDTVNPT_PasswordService",
    serialCert: "HDDTVNPT_SerialNumber",
    linkWS: "linkWS",
    IsHDDTToken: "IsHDDTToken",
    HDDTVNPTUrlPhatHanh: "HDDTVNPTUrlPhatHanh",
    Khonglamtrontien: "Khonglamtrontien",
    IsTruKhoNhapTruocXuatTruoc: "IsTruKhoNhapTruocXuatTruoc",
    CapNhatKieuGiaCongSanPham: "CapNhatKieuGiaCongSanPham",
    isChuagiacong: "isChuagiacong",
    isShowCanhBaoDonHangQuaHanKhiBanHang:
      "isShowCanhBaoDonHangQuaHanKhiBanHang",
    isChuagiacong: "isChuagiacong",
    AutoTruKhoGiaCong: "AutoTruKhoGiaCong",
    IsBanBuonBanLe: "IsBanBuonBanLe",
    HienThiTiTrong: "HienThiTiTrong",
    showTimeChiTietDonHang: "showTimeChiTietDonHang",
    TruKhoVaoNgayTao: "TruKhoVaoNgayTao",
    IsChoPhepBanAm: "IsChoPhepBanAm",
    SuaSanPhamBanHang: "SuaSanPhamBanHang",
    SHOW_TONGTHUOCTINHKHAC_THEONHOM: "SHOW_TONGTHUOCTINHKHAC_THEONHOM",
    IsPhanBoCongNoKhiTaoPhieuThu: "IsPhanBoCongNoKhiTaoPhieuThu",
    EditOrderUpdateStore: "EditOrderUpdateStore",
    isConfigXoaOrderKhiDaTruKho: "isConfigXoaOrderKhiDaTruKho",
    ConfigCkCongThuc: "ConfigCkCongThuc",
    GoiPhanMem: "GoiPhanMem",
    HienthiAutotrukhogiacong: "HienthiAutotrukhogiacong",
    Sanxuatonghop: "Sanxuatonghop",
    TraNCC: "TraNCC",
    BanHangLocTinhThanh: "BanHangLocTinhThanh",
    NhapThueSuat: "NhapThueSuat",
    IsCanhBaoBanGiaTrungBinh: "IsCanhBaoBanGiaTrungBinh",
    TONKHO_SHOW_TenSanPham: "TONKHO_SHOW_TenSanPham",
    TONKHO_SHOW_MaHang: "TONKHO_SHOW_MaHang",
    TONKHO_SHOW_NhomSanPham: "TONKHO_SHOW_NhomSanPham",
    TONKHO_SHOW_DangSuDung: "TONKHO_SHOW_DangSuDung",
    TONKHO_SHOW_ConLai: "TONKHO_SHOW_ConLai",
    TONKHO_SHOW_DonViXuat: "TONKHO_SHOW_DonViXuat",
    TONKHO_SHOW_DonViNhap: "TONKHO_SHOW_DonViNhap",
    TONKHO_SHOW_GiaVonNhap: "TONKHO_SHOW_GiaVonNhap",
    TONKHO_SHOW_ChiPhiKho: "TONKHO_SHOW_ChiPhiKho",
    TONKHO_SHOW_GiaNhap: "TONKHO_SHOW_GiaNhap",
    TONKHO_SHOW_TongGiaTri: "TONKHO_SHOW_TongGiaTri",
    TONKHO_SHOW_NgayNhap: "TONKHO_SHOW_NgayNhap",
    TONKHO_SHOW_ThaoTac: "TONKHO_SHOW_ThaoTac",
    TONKHO_SHOW_LoaiPhePham: "TONKHO_SHOW_LoaiPhePham",
    TONKHO_SHOW_TongTiTrong: "TONKHO_SHOW_TongTiTrong",
    SUDUNG_QRCODE: "SUDUNG_QRCODE",
    NVKD: "NVKD",
    Chiphikhacnhaphang: "Chiphikhacnhaphang",
    KGCXaGo: "KGCXaGo",
    isDinhKhoanKeToan: "isDinhKhoanKeToan",
    TatCanhBaoLuongTon: "TatCanhBaoLuongTon",

    // Cắt xẻ KGC
    IsCatXeKGC: "IsCatXeKGC",

    BaoCaoNhapHangHangNgay_MetDai: "BaoCaoNhapHangHangNgay_MetDai",
    BaoCaoNhapHangHangNgay_KLTheoTyTrong:
      "BaoCaoNhapHangHangNgay_KLTheoTyTrong",
    BaoCaoNhapHangHangNgay_GiaGoc: "BaoCaoNhapHangHangNgay_GiaGoc",
    BaoCaoNhapHangHangNgay_ThueGTGT: "BaoCaoNhapHangHangNgay_ThueGTGT",
    BaoCaoNhapHangHangNgay_TyTrong: "BaoCaoNhapHangHangNgay_TyTrong",
    BaoCaoNhapHangHangNgay_GhiChu: "BaoCaoNhapHangHangNgay_GhiChu",
    BaoCaoNhapHangHangNgay_Ngay: "BaoCaoNhapHangHangNgay_Ngay",
    BaoCaoNhapHangHangNgay_Code: "BaoCaoNhapHangHangNgay_Code",
    BaoCaoNhapHangHangNgay_Customer: "BaoCaoNhapHangHangNgay_Customer",
    BaoCaoNhapHangHangNgay_Address: "BaoCaoNhapHangHangNgay_Address",
    BaoCaoNhapHangHangNgay_NoiDung: "BaoCaoNhapHangHangNgay_NoiDung",
    BaoCaoNhapHangHangNgay_NhomKhachHang:
      "BaoCaoNhapHangHangNgay_NhomKhachHang",
    BaoCaoNhapHangHangNgay_NhomSanPham: "BaoCaoNhapHangHangNgay_NhomSanPham",
    BaoCaoNhapHangHangNgay_KieuGiaCong: "BaoCaoNhapHangHangNgay_KieuGiaCong",
    BaoCaoNhapHangHangNgay_LuongXuat: "BaoCaoNhapHangHangNgay_LuongXuat",
    BaoCaoNhapHangHangNgay_SoLuongXuat: "BaoCaoNhapHangHangNgay_SoLuongXuat",
    BaoCaoNhapHangHangNgay_Total: "BaoCaoNhapHangHangNgay_Total",
    BaoCaoNhapHangHangNgay_DVT: "BaoCaoNhapHangHangNgay_DVT",
    BaoCaoNhapHangHangNgay_DonGia: "BaoCaoNhapHangHangNgay_DonGia",
    BaoCaoNhapHangHangNgay_ThanhTien: "BaoCaoNhapHangHangNgay_ThanhTien",
    BaoCaoNhapHangHangNgay_PhiKhac: "BaoCaoNhapHangHangNgay_PhiKhac",
    BaoCaoNhapHangHangNgay_ChietKhau: "BaoCaoNhapHangHangNgay_ChietKhau",
    BaoCaoNhapHangHangNgay_TongTien: "BaoCaoNhapHangHangNgay_TongTien",
    BaoCaoNhapHangHangNgay_ThanhToan: "BaoCaoNhapHangHangNgay_ThanhToan",
    BaoCaoNhapHangHangNgay_ConNo: "BaoCaoNhapHangHangNgay_ConNo",
    BaoCaoNhapHangHangNgay_Kho: "BaoCaoNhapHangHangNgay_Kho",
    BaoCaoNhapHangHangNgay_MaCuon: "BaoCaoNhapHangHangNgay_MaCuon",

    BaoCaoBanHangHangNgay_Ngay: "BaoCaoBanHangHangNgay_Ngay",
    BaoCaoBanHangHangNgay_Customer: "BaoCaoBanHangHangNgay_Customer",
    BaoCaoBanHangHangNgay_LuongXuat: "BaoCaoBanHangHangNgay_LuongXuat",
    BaoCaoBanHangHangNgay_SoLuongXuat: "BaoCaoBanHangHangNgay_SoLuongXuat",
    BaoCaoBanHangHangNgay_TongSoTam: "BaoCaoBanHangHangNgay_TongSoTam",
    BaoCaoBanHangHangNgay_Total: "BaoCaoBanHangHangNgay_Total",
    BaoCaoBanHangHangNgay_DonGia: "BaoCaoBanHangHangNgay_DonGia",
    BaoCaoBanHangHangNgay_PhiKhac: "BaoCaoBanHangHangNgay_PhiKhac",
    BaoCaoBanHangHangNgay_TongTien: "BaoCaoBanHangHangNgay_TongTien",
    BaoCaoBanHangHangNgay_ConNo: "BaoCaoBanHangHangNgay_ConNo",
    BaoCaoBanHangHangNgay_Code: "BaoCaoBanHangHangNgay_Code",
    BaoCaoBanHangHangNgay_POCode: "BaoCaoBanHangHangNgay_POCode",
    BaoCaoBanHangHangNgay_Address: "BaoCaoBanHangHangNgay_Address",
    BaoCaoBanHangHangNgay_NoiDung: "BaoCaoBanHangHangNgay_NoiDung",
    BaoCaoBanHangHangNgay_SoLuong: "BaoCaoBanHangHangNgay_SoLuong",
    BaoCaoBanHangHangNgay_DVT: "BaoCaoBanHangHangNgay_DVT",
    BaoCaoBanHangHangNgay_ThanhTien: "BaoCaoBanHangHangNgay_ThanhTien",
    BaoCaoBanHangHangNgay_ChietKhau: "BaoCaoBanHangHangNgay_ChietKhau",
    BaoCaoBanHangHangNgay_ThanhToan: "BaoCaoBanHangHangNgay_ThanhToan",
    BaoCaoBanHangHangNgay_GhiChu: "BaoCaoBanHangHangNgay_GhiChu",
    BaoCaoBanHangHangNgay_ThueGTGT: "BaoCaoBanHangHangNgay_ThueGTGT",
    BaoCaoBanHangHangNgay_TyTrong: "BaoCaoBanHangHangNgay_TyTrong",
    BaoCaoBanHangHangNgay_TongTyTrong: "BaoCaoBanHangHangNgay_TongTyTrong",
    BaoCaoBanHangHangNgay_GiaTheoTyTrong:
      "BaoCaoBanHangHangNgay_GiaTheoTyTrong",
    BaoCaoBanHangHangNgay_NhomKhachHang: "BaoCaoBanHangHangNgay_NhomKhachHang",
    BaoCaoBanHangHangNgay_NhomSanPham: "BaoCaoBanHangHangNgay_NhomSanPham",
    BaoCaoBanHangHangNgay_KieuGiaCong: "BaoCaoBanHangHangNgay_KieuGiaCong",
    BaoCaoBanHangHangNgay_MetDai: "BaoCaoBanHangHangNgay_MetDai",
    BaoCaoBanHangHangNgay_KhoiLuongTheoTyTrong:
      "BaoCaoBanHangHangNgay_KhoiLuongTheoTyTrong",
    BaoCaoBanHangHangNgay_SDT: "BaoCaoBanHangHangNgay_SDT",
    IsBanHangTUTonKhoChiTiet: "IsBanHangTUTonKhoChiTiet",
    TaiKhoanDuocXoaDuLieu: "TaiKhoanDuocXoaDuLieu",

    TaiKhoanDuocXoaDuLieu: "TaiKhoanDuocXoaDuLieu",

    BaoCaoGiaoNhan_MaPGN: "BaoCaoGiaoNhan_MaPGN",
    BaoCaoGiaoNhan_Ngay: "BaoCaoGiaoNhan_Ngay",
    BaoCaoGiaoNhan_TaiXe: "BaoCaoGiaoNhan_TaiXe",
    BaoCaoGiaoNhan_Xe: "BaoCaoGiaoNhan_Xe",
    BaoCaoGiaoNhan_ChiPhiGN: "BaoCaoGiaoNhan_ChiPhiGN",
    BaoCaoGiaoNhan_MaDon: "BaoCaoGiaoNhan_MaDon",
    BaoCaoGiaoNhan_KhachHang: "BaoCaoGiaoNhan_KhachHang",
    BaoCaoGiaoNhan_TenSP: "BaoCaoGiaoNhan_TenSP",
    BaoCaoGiaoNhan_KGC: "BaoCaoGiaoNhan_KGC",
    BaoCaoGiaoNhan_LuongXuat: "BaoCaoGiaoNhan_LuongXuat",
    BaoCaoGiaoNhan_DonViTinh: "BaoCaoGiaoNhan_DonViTinh",
    BaoCaoGiaoNhan_MetDai: "BaoCaoGiaoNhan_MetDai",
    BaoCaoGiaoNhan_SoCay: "BaoCaoGiaoNhan_SoCay",
    BaoCaoGiaoNhan_DonGia: "BaoCaoGiaoNhan_DonGia",
    BaoCaoGiaoNhan_TyTrong: "BaoCaoGiaoNhan_TyTrong",
    BaoCaoGiaoNhan_KhoiLuong: "BaoCaoGiaoNhan_KhoiLuong",
    BaoCaoGiaoNhan_ThanhTien: "BaoCaoGiaoNhan_ThanhTien",
    BaoCaoGiaoNhan_ChiPhiKhac: "BaoCaoGiaoNhan_ChiPhiKhac",
    BaoCaoGiaoNhan_TongTien: "BaoCaoGiaoNhan_TongTien",
    BaoCaoGiaoNhan_ThanhToan: "BaoCaoGiaoNhan_ThanhToan",
    BaoCaoGiaoNhan_ConNo: "BaoCaoGiaoNhan_ConNo",
    BaoCaoGiaoNhan_Note: "BaoCaoGiaoNhan_Note",
    BaoCaoGiaoNhan_TrangThai: "BaoCaoGiaoNhan_TrangThai",

    PRINT_CHITIETCONGNOKH_SHOW_SOLUONG: "PRINT_CHITIETCONGNOKH_SHOW_SOLUONG",
    PRINT_CHITIETCONGNOKH_SHOW_DONVI: "PRINT_CHITIETCONGNOKH_SHOW_DONVI",
    PRINT_CHITIETCONGNOKH_SHOW_SOLUONG_KHONGDONVI:
      "PRINT_CHITIETCONGNOKH_SHOW_SOLUONG_KHONGDONVI",
    PRINT_CHITIETCONGNOKH_SHOW_DONGIA: "PRINT_CHITIETCONGNOKH_SHOW_DONGIA",
    PRINT_CHITIETCONGNOKH_SHOW_THANHTIEN:
      "PRINT_CHITIETCONGNOKH_SHOW_THANHTIEN",
    PRINT_CHITIETCONGNOKH_SHOW_CHIPHIKHAC:
      "PRINT_CHITIETCONGNOKH_SHOW_CHIPHIKHAC",
    PRINT_CHITIETCONGNOKH_SHOW_CHIETKHAU:
      "PRINT_CHITIETCONGNOKH_SHOW_CHIETKHAU",
    PRINT_CHITIETCONGNOKH_SHOW_TONGTIEN: "PRINT_CHITIETCONGNOKH_SHOW_TONGTIEN",
    PRINT_CHITIETCONGNOKH_SHOW_THANHTOAN:
      "PRINT_CHITIETCONGNOKH_SHOW_THANHTOAN",
    PRINT_CHITIETCONGNOKH_SHOW_NOTHEM: "PRINT_CHITIETCONGNOKH_SHOW_NOTHEM",
    PRINT_CHITIETCONGNOKH_SHOW_NOCUOI: "PRINT_CHITIETCONGNOKH_SHOW_NOCUOI",
    PRINT_CHITIETCONGNOKH_SHOW_GHICHU: "PRINT_CHITIETCONGNOKH_SHOW_GHICHU",
    PRINT_CHITIETCONGNOKH_SHOW_CODE: "PRINT_CHITIETCONGNOKH_SHOW_CODE",
    PRINT_CHITIETCONGNOKH_SHOW_TYTRONG: "PRINT_CHITIETCONGNOKH_SHOW_TYTRONG",
    PRINT_CHITIETCONGNOKH_SHOW_TONGTYTRONG:
      "PRINT_CHITIETCONGNOKH_SHOW_TONGTYTRONG",
    PRINT_CHITIETCONGNOKH_SHOW_GIATHEOTYTRONG:
      "PRINT_CHITIETCONGNOKH_SHOW_GIATHEOTYTRONG",
    PRINT_CHITIETCONGNOKH_SHOW_DIEUCHINHCONGNO:
      "PRINT_CHITIETCONGNOKH_SHOW_DIEUCHINHCONGNO",
    IsNhapCongThucNhanhTTK: "IsNhapCongThucNhanhTTK",
    IsGiaoNhanNhieuLan: "IsGiaoNhanNhieuLan",
    IsSuaDonBanGiaoNhan: "IsSuaDonBanGiaoNhan",
    TaiKhoanTaiXe: "TaiKhoanTaiXe",
    ConfigThongSoKyThuat: "ConfigThongSoKyThuat",
    IsPhanBoCongNoTheoSanPham: "IsPhanBoCongNoTheoSanPham",
    DAILY_DATHANG_VERSION2: "DAILY_DATHANG_VERSION2",
  },
  sRole: {
    LSX_DUTOANCHIPHI: "LSX_DUTOANCHIPHI",
    ChiPhiSanXuat: "ChiPhiSanXuat",
    ChiPhiMauSanXuat: "ChiPhiMauSanXuat",
    ChiPhiQuyTrinhSanXuat: "ChiPhiQuyTrinhSanXuat",
    ChiPhiMauQuyTrinhSanXuat: "ChiPhiMauQuyTrinhSanXuat",
    HT_XEMGIANHAPNHAPHANG: "HT_XEMGIANHAPNHAPHANG",
    HT_XEMGIANHAP: "HT_XEMGIANHAP",
    NHAPHANG_DEXUAT: "NHAPHANG_DEXUAT",
    IsConfigQuanLyKhoiLuong: "IsConfigQuanLyKhoiLuong",
    KH_ThemKhachHang: "KH_THEMKHACHHANG",
    KH_DANHSACH: "KH_DANHSACH",
    KH_SUAKHACHHANG: "KH_SUAKHACHHANG",
    KH_XOAKHACHHANG: "KH_XOAKHACHHANG",
    KH_NHAPEXCEL: "KH_NHAPEXCEL",
    KH_XUATEXCEL: "KH_XUATEXCEL",
    KH_KHOAMOKHACHHANG: "KH_KHOAMOKHACHHANG",
    KH_KHOAMODONHANG: "KH_KHOAMODONHANG",
    ////////////////////////////////////////////////////////////////
    HT_QuyenChuCuaHang: "HT_QUYENCHUCUAHANG",
    HT_DANHSACHTHIETLAPGIANHOMSANPHAM: "HT_DANHSACHTHIETLAPGIANHOMSANPHAM",
    HT_DANHSACHTHIETLAPGIASANPHAM: "HT_DANHSACHTHIETLAPGIASANPHAM",
    HT_THIETLAPGIA: "HT_THIETLAPGIA",
    HT_THIETLAPGIANHOMSANPHAM: "HT_THIETLAPGIANHOMSANPHAM",
    HT_NHOMSANPHAM: "HT_NHOMSANPHAM",
    HT_NHOMSANPHAM_PHANQUYENNGUOIXEM: "HT_NHOMSANPHAM_PHANQUYENNGUOIXEM",
    HT_DANHSACHKHO: "HT_DANHSACHKHO",
    HT_DUYETYEUCAU: "HT_DUYETYEUCAU",
    ////////////////////////////////////////////////////////////////
    NHAPHANG_THEMMOI: "NHAPHANG_THEMMOI",
    NHAPHANG_DANHSACHNHAPHANG: "NHAPHANG_DANHSACHNHAPHANG",
    NHAPHANG_SUA: "NHAPHANG_SUA",
    NHAPHANG_CHODUYET: "NHAPHANG_CHODUYET",
    NHAPHANG_CHODUYET_DANHSACH: "NHAPHANG_CHODUYET_DANHSACH",
    NHAPHANG_NHAPDAUKY: "NHAPHANG_NHAPDAUKY",
    ////////////////////////////////////////////////////////////////
    TRAHANG_THEMMOI: "TRAHANG_THEMMOI",
    TRAHANG_DANHSACH: "TRAHANG_DANHSACH",
    ////////////////////////////////////////////////////////////////
    KHO_KIEMKHO: "KHO_KIEMKHO",
    KHO_KIEMKHODANHSACH: "KHO_KIEMKHODANHSACH",
    KHO_KIEMKHOSUA: "KHO_KIEMKHOSUA",
    KHO_KIEMKHOXOA: "KHO_KIEMKHOXOA",
    ///////////////////////////////
    KHO_DSQUEUE: "KHO_DSQUEUE",
    ////////////////////////////////////////////////////////////////
    KT_BAOCAOLOINHUAN: "KT_BAOCAOLOINHUAN",
    KT_BAOCAOTAISAN: "KT_BAOCAOTAISAN",
    KT_TAIKHOANKETOAN: "KT_TAIKHOANKETOAN",
    KT_THEMTAIKHOANKETOAN: "KT_THEMTAIKHOANKETOAN",
    KT_BCKETQUAKINHDOANH: "KT_BCKETQUAKINHDOANH",
    KT_CHIETKHAUKHACHHANG: "KT_CHIETKHAUKHACHHANG",
    KT_DSCHIETKHAUKHACHHANG: "KT_DSCHIETKHAUKHACHHANG",
    KT_CHIETKHAUSANPHAM: "KT_CHIETKHAUSANPHAM",
    KT_DSCHIETKHAUSANPHAM: "KT_DSCHIETKHAUSANPHAM",
    KT_BCNHAPHANGSANPHAM: "KT_BCNHAPHANGSANPHAM",
    KT_QUYNGANHANG: "KT_QUYNGANHANG",
    KT_DANHSACHNHOMTHUCHI: "KT_DANHSACHNHOMTHUCHI",
    KT_THEMNHOMTHUCHI: "KT_THEMNHOMTHUCHI",
    KT_SUANHOMTHUCHI: "KT_SUANHOMTHUCHI",
    KT_XOANHOMTHUCHI: "KT_XOANHOMTHUCHI",

    //////////
    TRAHANG_NCC_XOA: "TRAHANG_NCC_XOA",
    TRAHANG_NCC_THEM: "TRAHANG_NCC_THEM",
    TRAHANG_NCC_DANHSACH: "TRAHANG_NCC_DANHSACH",
    TRAHANG_NCC_SUA: "TRAHANG_NCC_SUA",
    TRAHANG_NCC_DONNHAP: "TRAHANG_NCC_DONNHAP",
    //////////
    KH_BAOGIA_XOA: "KH_BAOGIA_XOA",
    KH_BAOGIA_SUA: "KH_BAOGIA_SUA",
    KH_BAOGIA_DANHSACH: "KH_BAOGIA_DANHSACH",
    KH_BAOGIA_THEM: "KH_BAOGIA_THEM",
    KH_BAOGIA_TAODONBANHANG: "KH_BAOGIA_TAODONBANHANG",
    KH_BAOGIA_TAODONXUATNHAPTHANG: "KH_BAOGIA_TAODONXUATNHAPTHANG",
    KH_BAOGIA_SUACHITIETSP: "KH_BAOGIA_SUACHITIETSP",

    ///
    NHAPHANG_DANHSACHDATHANG: "NHAPHANG_DANHSACHDATHANG",
    NHAPHANG_DATHANG: "NHAPHANG_DATHANG",
    NHAPHANG_DATHANG_SUA: "NHAPHANG_DATHANG_SUA",
    NHAPHANG_DATHANG_XOA: "NHAPHANG_DATHANG_XOA",
    NHAPHANG_HOANTHANHDONDATHANG: "NHAPHANG_HOANTHANHDONDATHANG",
    //

    HT_KIEUGIACONGHETHONG_GIATHANH: "HT_KIEUGIACONGHETHONG_GIATHANH",
    NHAPHANG_DATHANG_NHAPDICHVU: "NHAPHANG_DATHANG_NHAPDICHVU",
    NHAPHANG_DATHANG_NHAP: "NHAPHANG_DATHANG_NHAP",

    //Nhập hàng dịch vụ của đặt hàng
    KHO_DONHANGDV_DANHSACH: "KHO_DONHANGDV_DANHSACH",
    KHO_DONHANGDV_SUA: "KHO_DONHANGDV_SUA",
    KHO_DONHANGDV_XOA: "KHO_DONHANGDV_XOA",
    KHO_THEMLENHCAT: "KHO_THEMLENHCAT",
    //Danh sách chờ sản xuất
    KHO_LENHSX_DANHSACHCHOSX: "KHO_LENHSX_DANHSACHCHOSX",
    KHO_LENHSX_TAOPHIEUCHOSX: "KHO_LENHSX_TAOPHIEUCHOSX",
    // Danh sách đặt gia công:
    KHO_LENHCAT_DANHSACH: "KHO_LENHCAT_DANHSACH",
    KHO_LENHCAT_HOANTHANH: "KHO_LENHCAT_HOANTHANH",
    KHO_LENHCAT_XOA: "KHO_LENHCAT_XOA",
    // Danh sách lệnh sản xuất
    KHO_LENHSX_DANHSACHLENHSX: "KHO_LENHSX_DANHSACHLENHSX",
    KHO_LENHSX_XOA: "KHO_LENHSX_XOA",
    KHO_LENHSX_HOANTHANH: "KHO_LENHSX_HOANTHANH",
    // Danh sách kế hoạch giao nhận
    KHO_GIAONHAN_DANHSACH: "KHO_GIAONHAN_DANHSACH",
    KHO_GIAONHAN_TAOPHIEU: "KHO_GIAONHAN_TAOPHIEU",
    KHO_GIAONHAN_THEMVANCHUYEN: "KHO_GIAONHAN_THEMVANCHUYEN",
    KHO_GIAONHAN_SUAVANCHUYEN: "KHO_GIAONHAN_SUAVANCHUYEN",
    KHO_GIAONHAN_INVANCHUYEN: "KHO_GIAONHAN_INVANCHUYEN",
    KHO_GIAONHAN_INQUYDOI: "KHO_GIAONHAN_INQUYDOI",
    KHO_GIAONHAN_THEMPHIKHAC: "KHO_GIAONHAN_THEMPHIKHAC",
    //Danh sách phiếu giao nhận
    KHO_GIAONHAN_DANHSACHPHIEU: "KHO_GIAONHAN_DANHSACHPHIEU",
    KHO_GIAONHAN_HUYPHIEU: "KHO_GIAONHAN_HUYPHIEU",
    KHO_GIAONHAN_HOANTHANH: "KHO_GIAONHAN_HOANTHANH",
    GN_BAOCAO_BAOCAOGIAONHAN: "GN_BAOCAO_BAOCAOGIAONHAN",
    GN_BAOCAO_THIETLAPHIENTHI: "GN_BAOCAO_THIETLAPHIENTHI",
    GN_BAOCAO_INBAOCAO: "GN_BAOCAO_INBAOCAO",

    //Danh sách nhân viên kinh doanh
    HT_DANHSACHNHANVIENKINHDOANH: "HT_DANHSACHNHANVIENKINHDOANH",
    HT_CAPNHATTHONGTINNHANVIENKINHDOANH: "HT_CAPNHATTHONGTINNHANVIENKINHDOANH",

    //Danh sách nhân viên tài xế
    HT_DANHSACHNHANVIENTAIXE: "HT_DANHSACHNHANVIENTAIXE",
    HT_CAPNHATTHONGTINNHANVIENTAIXE: "HT_CAPNHATTHONGTINNHANVIENTAIXE",

    //Nhập xuất thẳng
    NHAPHANG_NXT_DANHSACH: "NHAPHANG_NXT_DANHSACH",
    NHAPHANG_NXT_SUA: "NHAPHANG_NXT_SUA",
    NHAPHANG_NXT_XOA: "NHAPHANG_NXT_XOA",
    NHAPHANG_NXT_THEMMOI: "NHAPHANG_NXT_THEMMOI",

    //Danh sách loại thu chi
    HT_XOALOAITHUCHI: "HT_XOALOAITHUCHI",
    HT_THEMLOAITHUCHI: "HT_THEMLOAITHUCHI",
    HT_SUALOAITHUCHI: "HT_SUALOAITHUCHI",
    HT_DANHSACHTHUCHI: "HT_DANHSACHTHUCHI",

    //Giá vốn
    NHAPHANG_GIAVON: "NHAPHANG_GIAVON",
    //hạn thanh toán form thêm mới khách hàng
    KH_ISSHOWHANTHANHTOAN: "KH_ISSHOWHANTHANHTOAN",
    // VỊ trí bản đồ
    VITRIBANDO: "VITRIBANDO",

    //Danh sách đơn hàng còn nợ
    BH_DanhSachDonDatHangCONNO: "BH_DanhSachDonDatHangCONNO",
    //Danh sách đơn hàng khách lẻ còn nợ
    BANHANG_DANHSACHKHACHLENO: "BANHANG_DANHSACHKHACHLENO",
    //cho phép nhập cuộn (maMbMc) form nhập hàng
    NHAPHANG_ISNHAPCUON: "NHAPHANG_ISNHAPCUON",

    // Chi phí kho
    NHAPHANG_CHIPHIKHO: "NHAPHANG_CHIPHIKHO",
    KHO_CHIPHIKHO: "KHO_CHIPHIKHO",
    NHAPHANG_SUACHITIETSP: "NHAPHANG_SUACHITIETSP",

    //trang chủ
    TC_TONGQUAN: "TC_TONGQUAN",
    HT_TRANGCHU: "HT_TRANGCHU",

    //định mức tồn kho:
    KHO_DINHMUCTONKHO: "KHO_DINHMUCTONKHO",

    // danh sách nhập hàng hiển thị tổng số cân
    NH_HIENTHITONGKG: "NH_HIENTHITONGKG",

    //ds điều chỉnh giá sản phẩm
    HT_DIEUCHINHGIANHOMSP: "HT_DIEUCHINHGIANHOMSP",

    //ds thiết lập chiết khấu sản phẩm
    HT_THIETLAPCHIETKHAU: "HT_THIETLAPCHIETKHAU",
    HT_TMTHIETLAPCHIETKHAU: "HT_TMTHIETLAPCHIETKHAU",
    HT_SUATHIETLAPCHIETKHAU: "HT_SUATHIETLAPCHIETKHAU",
    HT_XOATHIETLAPCHIETKHAU: "HT_XOATHIETLAPCHIETKHAU",
    HT_THIETLAPGIASANPHAM: "HT_THIETLAPGIASANPHAM",
    //ds đơn hàng quá hạn
    BANHANG_DanhSachDonDatHangQUAHAN: "BANHANG_DanhSachDonDatHangQUAHAN",
    BANHANG_THANHTOANDONHANGQUAHAN: "BANHANG_THANHTOANDONHANGQUAHAN",
    //ds đơn hàng xuất hóa đơn
    BANHANG_DanhSachDonDatHangXUATHOADON:
      "BANHANG_DanhSachDonDatHangXUATHOADON",

    BH_BAOCAOXUATHANGTHEODON: "BH_BAOCAOXUATHANGTHEODON",
    BH_BAOCAOXUATHANGTHEODON_INXUATEXCEL:
      "BH_BAOCAOXUATHANGTHEODON_INXUATEXCEL",
    //thiết lập giá theo kiểu gia công trong ds thiết lập giá nhóm sản phẩm
    HT_TLGIAKGCNSP: "HT_TLGIAKGCNSP",
    //phân hệ tổng quan khách hàng
    HT_NHOMKHACHHANG: "HT_NHOMKHACHHANG",
    KH_XEMCHITIETKHACHHANG: "KH_XEMCHITIETKHACHHANG",
    KH_XEMCONGNO: "KH_XEMCONGNO",
    KH_XEMCHITIETCONGNO: "KH_XEMCHITIETCONGNO",
    BC_BANHANGTHEOKHACHHANG: "BC_BANHANGTHEOKHACHHANG",
    BC_BAOCAOTHEONHOM: "BC_BAOCAOTHEONHOM",
    BC_THEODOITUOINO: "BC_THEODOITUOINO",
    KH_THONGTINKH: "KH_THONGTINKH",

    //Phân hệ Kho
    KHO_CHOXUATKHO: "KHO_CHOXUATKHO",
    KHO_NHAPKHO: "KHO_NHAPKHO",
    KHO_DANHSACHCHUYENKHO: "KHO_DANHSACHCHUYENKHO",
    KHO_CHUYENKHO: "KHO_CHUYENKHO",
    KHO_TONKHOTHEONHOM: "KHO_TONKHOTHEONHOM",
    KHO_TONKHOTHEOCUON: "KHO_TONKHOTHEOCUON",
    KHO_TONKHOTHEOMACUON: "KHO_TONKHOTHEOMACUON",
    KHO_TONKHORUTGON: "KHO_TONKHORUTGON",
    KHO_TONKHO: "KHO_TONKHO",
    KHO_CAPNHATSUDUNGMAHANG: "KHO_CAPNHATSUDUNGMAHANG",
    KHO_TONKHORUTGON_INXUATEXCEL: "KHO_TONKHORUTGON_INXUATEXCEL",
    //hạn mức công nợ trong form thêm mới/sửa khách hàng
    KH_HANMUCCONGNO: "KH_HANMUCCONGNO",

    //Hoá đơn giá trị gia tăng
    // NHAPHANG_HOADONGTGT: "NHAPHANG_HOADONGTGT",
    // TRAHANGSP_HOADONGTGT: "TRAHANGSP_HOADONGTGT",
    // TRAHANG_NCC_HOADONGTGT: "TRAHANG_NCC_HOADONGTGT",
    // NHAPHANG_DATHANG_HOADONGTGT: "NHAPHANG_DATHANG_HOADONGTGT",
    // KH_BAOGIA_THEM_HOADONGTGT: "KH_BAOGIA_THEM_HOADONGTGT",
    // NHAPHANG_DANHSACHDATHANG_HOADONGTGT: "NHAPHANG_DANHSACHDATHANG_HOADONGTGT",
    // NHAPHANG_NXT_THEMMOI_HOADONGTGT: "NHAPHANG_NXT_THEMMOI_HOADONGTGT",

    //Kho ngoài
    GIACONG_LENHTHUESANXUAT: "GIACONG_LENHTHUESANXUAT",
    GIACONG_SUALENHTHUESX: "GIACONG_SUALENHTHUESX",
    GIACONG_XOALENHTHUESX: "GIACONG_XOALENHTHUESX",
    // Tờ Khai thuế
    KT_TOKHAITHUE: "KT_TOKHAITHUE",
    KT_TOKHAITHUE_THEMMOI: "KT_TOKHAITHUE_THEMMOI",
    KT_TOKHAITHUE_XOA: "KT_TOKHAITHUE_XOA",
    KT_TOKHAITHUE_CHITIET: "KT_TOKHAITHUE_CHITIET",
    KT_TOKHAITHUE_XUATXML: "KT_TOKHAITHUE_XUATXML",

    // Chốt sổ kỳ kế toán
    KT_CHOTSOKETOAN: "KT_CHOTSOKETOAN",
    KT_CHOTSOKETOAN_THEMMOI: "KT_CHOTSOKETOAN_THEMMOI",
    KT_CHOTSOKETOAN_XOA: "KT_CHOTSOKETOAN_XOA",

    // Dòng tiền
    KT_THEMPHIEUTHUDUKIEN: "KT_THEMPHIEUTHUDUKIEN",
    KT_THEMPHIEUCHIDUKIEN: "KT_THEMPHIEUCHIDUKIEN",
    KT_DANHSACHPHIEUTHUCHIDUKIEN: "KT_DANHSACHPHIEUTHUCHIDUKIEN",
    KT_SUAPHIEUTHUCHIDUKIEN: "KT_SUAPHIEUTHUCHIDUKIEN",
    KT_XOAPHIEUTHUCHIDUKIEN: "KT_XOAPHIEUTHUCHIDUKIEN",
    KT_INPHIEUTHUCHIDUKIEN: "KT_INPHIEUTHUCHIDUKIEN",
    KETOAN_BAOCAODONGTIEN: "KETOAN_BAOCAODONGTIEN",

    // Quỹ tiền tài xế
    KT_QUYTAIXE: "KT_QUYTAIXE",
    // Duyệt yêu cầu tài xế
    HT_DUYETYEUCAUTAIXE: "HT_DUYETYEUCAUTAIXE",

    // báo cáo lợi nhuận theo nhóm sản phẩm
    KT_BAOCAOLOINHUANTHEONHOMSANPHAM: "KT_BAOCAOLOINHUANTHEONHOMSANPHAM",

    //xuất nhập thẳng
    BH_ISSHOWHANTHANHTOAN: "BH_ISSHOWHANTHANHTOAN",

    //THêm mới bán hàng
    BANHANG_THEMDHNHOHONHIENTAI: "BANHANG_THEMDHNHOHONHIENTAI",
    BANHANG_GIAVON: "BANHANG_GIAVON",
    BH_ISBANCUON: "BH_ISBANCUON",
    BH_ISSHOWNOTEMAMC: "BH_ISSHOWNOTEMAMC",
    BANHANG_THEMDH: "BANHANG_THEMDH",
    BANHANG_CANHBAOBANGIATRUNGBINH: "BANHANG_CANHBAOBANGIATRUNGBINH",
    BH_SUACHITIETSP: "BH_SUACHITIETSP",

    //Nhan viên kinh doanh
    NVKD_QUANLYNOTHEONVKD_CHOTNO: "NVKD_QUANLYNOTHEONVKD_CHOTNO",

    BANHANG_SUATHONGTINKH: "BANHANG_SUATHONGTINKH",
    BANHANG_SUAGIA: "BANHANG_SUAGIA",
    BANHANG_IsSuaGiaOrderTrong5Ngay: "BANHANG_IsSuaGiaOrderTrong5Ngay",
    BANHANG_SUADH: "BANHANG_SUADH",
    BANHANG_XOADH: "BANHANG_XOADH",
    BANHANG_SUADHQUANGAY: "BANHANG_SUADHQUANGAY",
    //Thêm sản phẩm
    HT_CONGTHUCSANPHAM: "HT_CONGTHUCSANPHAM",
    HT_CHECKTHUEGTGT: "HT_CHECKTHUEGTGT",
    HT_ISSHOWNHAPXUATCUON: "HT_ISSHOWNHAPXUATCUON",
    // roles in , xuất excel
    KT_DSTAISAN_INXUATEXCEL: "KT_DSTAISAN_INXUATEXCEL",
    KT_DSTHANHLY_INXUATEXCEL: "KT_DSTHANHLY_INXUATEXCEL",
    KT_DSKHAUHAO_INXUATEXCEL: "KT_DSKHAUHAO_INXUATEXCEL",
    NVKD_QUANLYNOTHEOKHACHHANG_INXUATEXCEL:
      "NVKD_QUANLYNOTHEOKHACHHANG_INXUATEXCEL",
    NVKD_BAOCAOTHEOSANPHAM_INXUATEXCEL: "NVKD_BAOCAOTHEOSANPHAM_INXUATEXCEL",
    NVKD_QUANLYNOTHEONVKD_INXUATEXCEL: "NVKD_QUANLYNOTHEONVKD_INXUATEXCEL",
    KT_BCKETQUAKINHDOANH_INXUATEXCEL: "KT_BCKETQUAKINHDOANH_INXUATEXCEL",
    KT_BAOCAOLOINHUANTHEONHOMSANPHAM_INXUATEXCEL:
      "KT_BAOCAOLOINHUANTHEONHOMSANPHAM_INXUATEXCEL",
    KT_BAOCAOLOINHUAN_INXUATEXCEL: "KT_BAOCAOLOINHUAN_INXUATEXCEL",
    KT_BCQuanLyGiaVon_INXUATEXCEL: "KT_BCQuanLyGiaVon_INXUATEXCEL",
    KHO_LENHCAT_DANHSACH_INXUATEXCEL: "KHO_LENHCAT_DANHSACH_INXUATEXCEL",
    LSX_CANHBAOLUONGTON_INXUATEXCEL: "LSX_CANHBAOLUONGTON_INXUATEXCEL",
    KHO_LENHSX_DANHSACHCHOSX_INXUATEXCEL:
      "KHO_LENHSX_DANHSACHCHOSX_INXUATEXCEL",
    KHO_GIAONHAN_DANHSACHPHIEU_INXUATEXCEL:
      "KHO_GIAONHAN_DANHSACHPHIEU_INXUATEXCEL",
    KHO_THEMLSX_INXUATEXCEL: "KHO_THEMLSX_INXUATEXCEL",
    NHAPHANG_NXT_DANHSACH_INXUATEXCEL: "NHAPHANG_NXT_DANHSACH_INXUATEXCEL",
    TRAHANG_DANHSACH_INXUATEXCEL: "TRAHANG_DANHSACH_INXUATEXCEL",
    TRAHANGSP_DANHSACHTRAHANGSANPHAM_INXUATEXCEL:
      "TRAHANGSP_DANHSACHTRAHANGSANPHAM_INXUATEXCEL",
    TRAHANGSP_DANHSACHTRAHANGSANPHAMNEW_INXUATEXCEL:
      "TRAHANGSP_DANHSACHTRAHANGSANPHAMNEW_INXUATEXCEL",
    TRAHANG_NCC_DANHSACH_INXUATEXCEL: "TRAHANG_NCC_DANHSACH_INXUATEXCEL",
    NHAPHANG_DANHSACHNHAPHANG_INXUATEXCEL:
      "NHAPHANG_DANHSACHNHAPHANG_INXUATEXCEL",
    NHAPHANG_DANHSACHDATHANG_INXUATEXCEL:
      "NHAPHANG_DANHSACHDATHANG_INXUATEXCEL",
    KHO_DONHANGDV_DANHSACH_INXUATEXCEL: "KHO_DONHANGDV_DANHSACH_INXUATEXCEL",
    BANHANG_DanhSachDonDatHang_INXUATEXCEL:
      "BANHANG_DanhSachDonDatHang_INXUATEXCEL",
    KH_BAOGIA_DANHSACH_INXUATEXCEL: "KH_BAOGIA_DANHSACH_INXUATEXCEL",
    BH_DanhSachDonDatHangCONNO_INXUATEXCEL:
      "BH_DanhSachDonDatHangCONNO_INXUATEXCEL",
    BANHANG_DanhSachDonDatHangQUAHAN_INXUATEXCEL:
      "BANHANG_DanhSachDonDatHangQUAHAN_INXUATEXCEL",
    BANHANG_DanhSachDonDatHangCHODUYET_INDON:
      "BANHANG_DanhSachDonDatHangCHODUYET_INDON",
    BANHANG_DanhSachDonDatHangXUATHOADON_INXUATEXCEL:
      "BANHANG_DanhSachDonDatHangXUATHOADON_INXUATEXCEL",
    KH_DANHSACH_INXUATEXCEL: "KH_DANHSACH_INXUATEXCEL",
    KHO_KIEMKHODANHSACH_INXUATEXCEL: "KHO_KIEMKHODANHSACH_INXUATEXCEL",
    // Giá vốn
    THTD_XEMGIAGOC: "THTD_XEMGIAGOC", // Trả hàng theo đơn
    THSP_XEMGIAGOC: "THSP_XEMGIAGOC", // Trả hàng theo sản phẩm
    THDD_XEMGIAGOC: "THDD_XEMGIAGOC", // Trả hàng sản phẩm đích danh
    LSX_TAOLENH: "LSX_TAOLENH",
    BC_SOCHITIETCACTAIKHOAN_INXUATEXCEL: "BC_SOCHITIETCACTAIKHOAN_INXUATEXCEL",
    GCT_TONKHOKHACHHANG: "GCT_TONKHOKHACHHANG",

    LSX_THEMYEUCAUSX: "LSX_THEMYEUCAUSX",
    LSX_YEUCAUSXDANHSACH: "LSX_YEUCAUSXDANHSACH",
    LSX_DANHSACHLSXTHEOYC: "LSX_DANHSACHLSXTHEOYC",

    QTSX_MAUQUYTRINHSANXUAT: "QTSX_MAUQUYTRINHSANXUAT",
    QTSX_DANHSACHLENHSANXUATQUYTRINH: "QTSX_DANHSACHLENHSANXUATQUYTRINH",
    HT_XOADONVIBAN: "HT_XOADONVIBAN",
    HT_SUADONVIBAN: "HT_SUADONVIBAN",
    HT_THEMDONVIBAN: "HT_THEMDONVIBAN",
    HT_DANHSACHDONVIBAN: "HT_DANHSACHDONVIBAN",

    // Vận chuyển
    GN_VANCHUYEN_DANHSACHXE: "GN_VANCHUYEN_DANHSACHXE",
    GN_VANCHUYEN_THEMMOIXE: "GN_VANCHUYEN_THEMMOIXE",
    GN_VANCHUYEN_SUATHONGTINXE: "GN_VANCHUYEN_SUATHONGTINXE",
    GN_VANCHUYEN_XOATHONGTINXE: "GN_VANCHUYEN_XOATHONGTINXE",

    GN_VANCHUYEN_DANHSACHLAIXE: "GN_VANCHUYEN_DANHSACHLAIXE",
    GN_VANCHUYEN_THEMMOILAIXE: "GN_VANCHUYEN_THEMMOILAIXE",
    GN_VANCHUYEN_SUATHONGTINLAIXE: "GN_VANCHUYEN_SUATHONGTINLAIXE",
    GN_VANCHUYEN_XOATHONGTINLAIXE: "GN_VANCHUYEN_XOATHONGTINLAIXE",

    HT_THONGBAO: "HT_THONGBAO",
  },
  sTrangThaiRequestAPI: {
    ChuaGoi: "ChuaGoi",
    DangGoi: "DangGoi",
    Success: "Success",
    Failed: "Failed",
  },
  imageServer: window.imageServer,
  apiUpload: window.apiUpload,
  apiViewUpload: window.apiViewUpload,
  sLoaiTuDien: {
    LoaiPhieuThu: "LoaiPhieuThu",
    LoaiPhieuChi: "LoaiPhieuChi",
  },
  cCashType: {
    QUY_TIENMAT: "QUY_TIENMAT",
    QUY_NGANHANG: "QUY_NGANHANG",
    QUY_TAIXE: "QUY_TAIXE",
    QUY_NHAPDV: "QUY_NHAPDV",
  },
};
